import { getGlobalHeadersAsObject } from "./global-headers";
import type { DRFListResponseWrapper } from "./types";

export type EmailJournalPerson = {
	id: number;
	email_type: number;
	email_type_display: string;
	person: number;
	person_id: number;
	person_name: string;
	email_journal: number;
	email_journal_id: number;
};

export const getEmailJournalPersonsByEmailJournalId = (
	emailJournalId: number
): Promise<DRFListResponseWrapper<EmailJournalPerson[]>> => {
	return fetch(`/api/v2/email-journal-person/?email_journal_id=${emailJournalId}`, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => res.json());
};
